/* ===================================================================
   xoxo+ Custom Layer — shared JS
   Cursor tracking + IntersectionObserver reveal
   =================================================================== */
(function () {
  'use strict';

  if (!document.body || !/\bxoxo-/.test(document.body.className)) return;

  /* ── Cursor ─── */
  var cur = document.querySelector('.xoxo-cur');
  var glow = document.querySelector('.xoxo-cur-glow');
  var isTouch = matchMedia('(hover: none) and (pointer: coarse)').matches;

  if (cur && glow && !isTouch) {
    document.addEventListener('mousemove', function (e) {
      cur.style.left = glow.style.left = e.clientX + 'px';
      cur.style.top  = glow.style.top  = e.clientY + 'px';
      cur.style.opacity = glow.style.opacity = 1;
    });
    document.addEventListener('mouseleave', function () {
      cur.style.opacity = glow.style.opacity = 0;
    });
    document.addEventListener('mouseenter', function () {
      cur.style.opacity = glow.style.opacity = 1;
    });
  }

  /* ── Reveal ─── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.xoxo-reveal').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.xoxo-reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }
})();
